<script>
  import SelectBooksForm from '@/components/select-books-form.vue'
  import SelectBooksSummary from '@/components/select-books-submission-summary.vue'
  export default {
    name: 'select-books',
    components: { SelectBooksForm, SelectBooksSummary },
    data: () => ({
      formData: {},
      isSuccess: false
    }),
    computed: {},
    methods: {
      async onSuccess(formData) {
        this.isSuccess = true
        this.formData = { ...formData }
        await this.$nextTick()
        if (this.$refs?.submissionSummary?.$el) {
          this.$refs.submissionSummary.$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      }
    },
    created() {}
  }
</script>

<template>
  <v-container class="d-flex flex-column align-center mb-12 rounded-lg">
    <h1 class="text-h2 text-center primary--text font-weight-bold">Select Books</h1>
    <v-card max-width="1200px" width="100%" class="mt-16">
      <v-card-text class="primary--text">
        <img height="200px" width="300px" src="https://media.eipl.org/site/images/services/select-books.jpg" class="d-block my-4 rounded mx-auto" />
        <p class="text-h5 primary--text font-weight-bold my-12">Let us help you put together a list of good reads!</p>
        <p class="text-body-1 primary--text text--lighten-2 font-weight-bold mb-0">Read everything your favorite author has written and want to read more?</p>
        <p class="text-body-1 primary--text text--lighten-2 font-weight-bold">Want a read-a-like of your favorite title?</p>
        <p class="text-body-1 primary-text">
          Just complete as many questions as you like on the form below and the staff will create a custom book list for you within 72 hours. The more you tell us about your
          reading habits, the better we can match you with a list of new reading suggestions.
        </p>
        <!-- TODO: implement this! -->
        <!-- <p class="text-body-1 font-italic primary-text">If you would like to retrieve or update entries in the future, please provide both your E-mail AND Library Barcode.</p> -->
      </v-card-text>
    </v-card>
    <v-sheet color="transparent" max-width="1200px" width="100%" class="rounded my-8">
      <template v-if="isSuccess">
        <v-card ref="submissionSummary">
          <v-card-title>
            <h2 class="success--text">Thank You for Your Submission!</h2>
          </v-card-title>
          <v-card-text>
            <p class="text-body-1 mb-2">You will receive a confirmation E-mail shortly.</p>
            <p class="text-body-1 mb-2">Please allow for up to 72 hours for a follow up E-mail with your curated reading lists.</p>
          </v-card-text>
        </v-card>
        <select-books-summary :formData="formData" class="mt-4"></select-books-summary>
      </template>
      <select-books-form v-else @success="onSuccess"></select-books-form>
    </v-sheet>
  </v-container>
</template>

<style scoped></style>
